import { ServiceSummaryFilters } from "@madhive/mad-sdk";

export const EMPTY_CSV_EXPORT_PARAMS: ServiceSummaryFilters = {
  parent_id: "",
  owner_ids: [],
  start: "",
  end: "",
  products: [],
  adbook_package_id: "",
  campaign_ids: [],
  line_item_ids: []
};
